import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";

@Component({
  selector: "hospice-visits-table",
  templateUrl: "hospice-visits-table.html",
})
export class HospiceVisitsTable implements OnInit, OnDestroy {
  @Input() hospiceVisitRates: any[];
  @Output() onRateChanged = new EventEmitter<any>();

  ngOnDestroy(): void {}

  ngOnInit(): void {}

  constructor() {}

  rateChanged() {
    this.onRateChanged.emit(this.hospiceVisitRates);
  }
}



// WEBPACK FOOTER //
// ./src/components/payers/rates-payer/hospice-visits/hospice-visits-table/hospice-visits-table.ts